import type Phaser from 'phaser';
import { PALETTE, FONT, px } from '../theme';
import { audio } from '../audio/engine';

/**
 * Schlichte Schaltflaeche im Seekarten-Stil: eine duenne Umrandung, die beim
 * Ueberfahren aufhellt. Bewusst ohne Grafik-Assets, damit der Look sich in
 * einem Schritt aendern laesst.
 */
export function createButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
  label: string,
  onClick: () => void,
  options: { width?: number; height?: number; fontSize?: number } = {},
): Phaser.GameObjects.Container {
  const fontSize = options.fontSize ?? 15;

  // Den Text zuerst anlegen und dann den Rahmen darum bauen. Andersherum —
  // feste Breite, Text hinein — stand die Beschriftung ueber dem Rand, sobald
  // die Schriftgroesse hochgestellt war. Die angegebene Breite ist deshalb
  // eine Untergrenze, keine Vorgabe.
  const text = scene.add
    .text(0, 0, label, {
      fontFamily: FONT.mono,
      fontSize: px(fontSize),
      color: PALETTE.inkDim,
    })
    .setOrigin(0.5);

  const width = Math.max(options.width ?? 200, text.width + 28);
  const height = Math.max(options.height ?? 42, text.height + 14);

  const frame = scene.add.rectangle(0, 0, width, height, PALETTE.panel);
  frame.setStrokeStyle(1, PALETTE.panelEdge);

  const container = scene.add.container(x, y, [frame, text]);
  // Die tatsaechliche Breite muss ablesbar sein: Leisten, die mehrere
  // Schaltflaechen nebeneinander setzen, rechnen damit.
  container.setSize(width, height);
  container.setInteractive({ useHandCursor: true });

  container.on('pointerover', () => {
    frame.setStrokeStyle(1, PALETTE.coast);
    text.setColor(PALETTE.ink);
  });

  container.on('pointerout', () => {
    frame.setStrokeStyle(1, PALETTE.panelEdge);
    text.setColor(PALETTE.inkDim);
  });

  container.on('pointerdown', () => {
    // Browser lassen Audio erst nach einer Nutzerhandlung zu — jede Bedienung
    // weckt den Ton, statt sich auf einen einzelnen Handler zu verlassen.
    audio.resume();
    onClick();
  });

  return container;
}
